import { EMarketTypes } from "../../../../interfaces";
import { DataEstimateContext, IDataModal } from "../../../pages/estimate";
import FormEstimateMarketPrice from "../../../pages/estimate/components/forms/formMarketPrice/formEstimateMarketPrice";

interface IAboutFacilityForm {
  onChange: (data: Partial<IDataModal> | null) => void;
  marketType: EMarketTypes;
}

const AboutFacilityFrom = ({ onChange, marketType }: IAboutFacilityForm) => {
  return (
    <DataEstimateContext.Provider
      value={{
        dataModal: null,
        onSetDataModal: onChange,
      }}
    >
      <FormEstimateMarketPrice
        isSecondarySwitcher={marketType === EMarketTypes.SECONDARY}
        mode='aboutFacilityForm'
      />
    </DataEstimateContext.Provider>
  );
};

export default AboutFacilityFrom;
